'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _appVerifiedStepRoutes = require('../../core/constants/appVerifiedStepRoutes');

var _appVerifiedStepRoutes2 = _interopRequireDefault(_appVerifiedStepRoutes);

var _Lazy = require('../../core/routeHandlers/Lazy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var verifiedStandardStepsParams = {
  surveyStep: {
    route: _appVerifiedStepRoutes2.default.SURVEY,
    handler: function handler(props) {
      return _react2.default.createElement(
        _react2.default.Suspense,
        { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
        _react2.default.createElement(_Lazy.StandardSurvey, props)
      );
    }
  }
};

exports.default = verifiedStandardStepsParams;
module.exports = exports['default'];